import { application } from "./application";

import AdImageValidatorController from "./ad_image_validator_controller";
import AdInlineEditorController from "./ad_inline_editor_controller";
import AsyncDownloadCsvController from "./async_download_csv_controller";
import AttendanceListController from "./attendance_list_controller";
import AutosubmitController from "./autosubmit_controller";
import CalendarController from "./calendar_controller";
import CampaignFormController from "./campaign_form_controller";
import ChangeCountryController from "./change_country_controller";
import ClipboardController from "./clipboard_controller";
import CouponFormController from "./coupon_form_controller";
import CsvButtonController from "./csv_button_controller";
import DropdownController from "./dropdown_controller";
import FileFieldImagePreviewerController from "./file_field_image_previewer_controller";
import FormController from "./form_controller";
import GoToController from "./go_to_controller";
import GymFormController from "./gym_form_controller";
import GymMapController from "./gym_map_controller";
import GymPaymentReportFormController from "./gym_payment_report_form_controller";
import GymPaymentsReportsShowController from "./gym_payments_reports_show_controller";
import GymPaymentsUploadInvoiceFormController from "./gym_payments_upload_invoice_form_controller";
import GymSelectController from "./gym_select_controller";
import HelloController from "./hello_controller";
import LessonFormController from "./lesson_form_controller";
import LinkController from "./link_controller";
import ModalController from "./modal_controller";
import ModalFormController from "./modal_form_controller";
import NestedFormController from "./nested_form_controller";
import OffcanvasController from "./offcanvas_controller";
import PaginationButtonController from "./pagination_button_controller";
import PlanBillingReportFormController from "./plan_billing_report_form_controller";
import PreviewImageDialogController from "./preview_image_dialog_controller";
import RailsNestedFormController from "./rails_nested_form_controller";
import ReloadController from "./reload_controller";
import ReservationStatusModalController from "./reservation_status_modal_controller";
import ReservationsSearchController from "./reservations_search_controller";
import ScheduleFormController from "./schedule_form_controller";
import SchedulesBatchActionsController from "./schedules_batch_actions_controller";
import ShellController from "./shell_controller";
import SortButtonController from "./sort_button_controller";
import SubmitNowController from "./submit_now_controller";
import ThemeController from "./theme_controller";
import ToastController from "./toast_controller";

// Nested controllers
import CalendarsMobileController from "./calendars/mobile_controller";
import ComponentsResponsiveModalController from "./components/responsive_modal_controller";
import GymsPaymentsController from "./gyms/payments_controller";

application.register("ad-image-validator", AdImageValidatorController);
application.register("ad-inline-editor", AdInlineEditorController);
application.register("async-download-csv", AsyncDownloadCsvController);
application.register("attendance-list", AttendanceListController);
application.register("autosubmit", AutosubmitController);
application.register("calendar", CalendarController);
application.register("campaign-form", CampaignFormController);
application.register("change-country", ChangeCountryController);
application.register("clipboard", ClipboardController);
application.register("coupon-form", CouponFormController);
application.register("csv-button", CsvButtonController);
application.register("dropdown", DropdownController);
application.register("file-field-image-previewer", FileFieldImagePreviewerController);
application.register("form", FormController);
application.register("go-to", GoToController);
application.register("gym-form", GymFormController);
application.register("gym-map", GymMapController);
application.register("gym-payment-report-form", GymPaymentReportFormController);
application.register("gym-payments-reports-show", GymPaymentsReportsShowController);
application.register("gym-payments-upload-invoice-form", GymPaymentsUploadInvoiceFormController);
application.register("gym-select", GymSelectController);
application.register("hello", HelloController);
application.register("lesson-form", LessonFormController);
application.register("link", LinkController);
application.register("modal", ModalController);
application.register("modal-form", ModalFormController);
application.register("nested-form", NestedFormController);
application.register("offcanvas", OffcanvasController);
application.register("pagination-button", PaginationButtonController);
application.register("plan-billing-report-form", PlanBillingReportFormController);
application.register("preview-image-dialog", PreviewImageDialogController);
application.register("rails-nested-form", RailsNestedFormController);
application.register("reload", ReloadController);
application.register("reservation-status-modal", ReservationStatusModalController);
application.register("reservations-search", ReservationsSearchController);
application.register("schedule-form", ScheduleFormController);
application.register("schedules-batch-actions", SchedulesBatchActionsController);
application.register("shell", ShellController);
application.register("sort-button", SortButtonController);
application.register("submit-now", SubmitNowController);
application.register("theme", ThemeController);
application.register("toast", ToastController);

// Nested controllers
application.register("calendars--mobile", CalendarsMobileController);
application.register("components--responsive-modal", ComponentsResponsiveModalController);
application.register("gyms--payments", GymsPaymentsController);
